import './NewsCard.css';
import { Portal } from 'react-portal';
import CloseIcon from '../../../Images/close-icon-white.png';
import { useNewsCard } from './useNewsCard';
import './Richtext.css';
// Translate
import { useTranslation } from 'react-i18next';

const NewsCard = ({
	backgroundImage,
	title,
	description,
	category,
	content,
}) => {
	const { t } = useTranslation();
	const { bgUrl, handleCloseModal, handleOpenModal, isModalOpen } =
		useNewsCard(backgroundImage);

	return (
		<>
			{isModalOpen && (
				<Portal>
					<div className='modal-news-card-container'>
						<div className='modal-news-card'>
							<div className='modal-news-card-main-content'>
								<div className='close-btn'>
									<img src={CloseIcon} alt='' />
								</div>
								<div className='image-banner'>
									<img src={bgUrl} alt='news banner' />
								</div>

								<div className='content-header'>
									<div className='new-resource-tag-btn'>{t('New Resources')}</div>
								</div>
								<div className='modal-news-card-title'>{title}</div>
								<div
									className='content'
									dangerouslySetInnerHTML={{ __html: content }}
								></div>

								<div className='content-bottom'>
									<button
										className='new-resource-tag-btn'
										onClick={handleCloseModal}
									>
										{t('Close')}
									</button>
								</div>
							</div>
						</div>
					</div>
				</Portal>
			)}

			<div
				className={`news-new-carousel-card add-zoom`}
				style={{
					backgroundImage: `url("${bgUrl}")`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					position: 'relative',
				}}
				onClick={handleOpenModal}
			>
				{/* overlay */}
				<div
					style={{
						position: 'absolute',
						inset: 0,
						backgroundColor: 'rgba(0,0,0,0.5)',
						borderRadius: '10px',
					}}
				/>
				<div className='new-resource-tag'>{t('New Resources')}</div>
				<div
					className='news-card-content'
					style={{ position: 'relative', zIndex: 1 }}
				>
					<div className='news-category'>{category}</div>
					<div className='news-title'>{title}</div>
					<div className='news-description'>{description}</div>
				</div>
			</div>
		</>
	);
};

export default NewsCard;
